import React from "react";
import "./style.scss";
import { formatMessage } from "devextreme/localization";

export default function Others({ employee = {} }) {
  return (
    <div>
      <div className="form-readonly ma-2">
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">{formatMessage("Vehicle")}</div>
            <div className="form-value">
              <span>{employee?.Vehicle}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">
              {formatMessage("CompanyCarNumber")}
            </div>
            <div className="form-value">
              <span>{employee?.CompanyCarNumber}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">{formatMessage("InsuranceMonths")}</div>
            <div className="form-value">
              <span>{employee?.InsuranceMonths}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">{formatMessage("RemarkFirst")}</div>
            <div className="form-value">
              <span>{employee?.RemarkFirst}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">{formatMessage("RemarkSecond")}</div>
            <div className="form-value">
              <span>{employee?.RemarkSecond}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">{formatMessage("RemarkThird")}</div>
            <div className="form-value">
              <span>{employee?.RemarkThird}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">
              {formatMessage("DrivingLicenseNo")}
            </div>
            <div className="form-value">
              <span>{employee?.DrivingLicenseNo}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">{formatMessage("NumberOfKm")}</div>
            <div className="form-value">
              <span>{employee?.KmQuantity}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
